import PageWrapper from '@app/components/layout/PageWrapper';
import FullLoader from '@app/components/ui/FullLoader';
import DoctorDashboardPage from '@pages/doctorPortal/DoctorDashboardPage';
import DoctorMeasurementsPage from '@pages/doctorPortal/DoctorMeasurementsPage';
import DoctorPatientCardPage from '@pages/doctorPortal/DoctorPatientCardPage';
import DoctorPatientsPage from '@pages/doctorPortal/DoctorPatientsPage';
import DoctorProfilePage from '@pages/doctorPortal/DoctorProfilePage';
import DoctorVisitsPage from '@pages/doctorPortal/DoctorVisitsPage';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const DoctorOverviewRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('doctor-dashboard-page-title')}>
        <DoctorDashboardPage />
      </PageWrapper>
    </Suspense>
  );
};

const DoctorPatientsRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('doctor-patients-page-title')}>
        <DoctorPatientsPage />
      </PageWrapper>
    </Suspense>
  );
};

const DoctorMeasurementsRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('doctor-measurements-page-title')}>
        <DoctorMeasurementsPage />
      </PageWrapper>
    </Suspense>
  );
};

const DoctorVisitsRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('doctor-visits-page-title')}>
        <DoctorVisitsPage />
      </PageWrapper>
    </Suspense>
  );
};

const DoctorProfileRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('doctor-profile-page-title')}>
        <DoctorProfilePage />
      </PageWrapper>
    </Suspense>
  );
};

const DoctorPatientCardRoute = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<FullLoader />}>
      <PageWrapper title={t('client-card-page-title')}>
        <DoctorPatientCardPage />
      </PageWrapper>
    </Suspense>
  );
};

export default {
  DoctorOverviewRoute,
  DoctorPatientCardRoute,
  DoctorPatientsRoute,
  DoctorVisitsRoute,
  DoctorMeasurementsRoute,
  DoctorProfileRoute,
};
